import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CreatePortalHOC from "../Fields/CreatePortalHOC";

const MuiLoader = ({ isOpen }) => {
  return (
    <CreatePortalHOC isOpen={isOpen} dialog customZIndex={9999999999}>
      <Box sx={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", zIndex: 99999999 }}>
        <CircularProgress />
      </Box>
    </CreatePortalHOC>
  );
};

export default MuiLoader;
